var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c(_vm.currentView,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }